import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const images = {
  "plot-10-off": `${config.ASSETS_URL}/03/13/principle/d0.1_dd.png`,
  "plot-10-on": `${config.ASSETS_URL}/03/13/principle/d0.1_ddFlank.png`,
  "plot-20-off": `${config.ASSETS_URL}/03/13/principle/d0.2_dd.png`,
  "plot-20-on": `${config.ASSETS_URL}/03/13/principle/d0.2_ddFlank.png`,
  "plot-30-off": `${config.ASSETS_URL}/03/13/principle/d0.3_dd.png`,
  "plot-30-on": `${config.ASSETS_URL}/03/13/principle/d0.3_ddFlank.png`,
  "room-10-off": `${config.ASSETS_URL}/03/13/principle/room11.svg`,
  "room-10-on": `${config.ASSETS_URL}/03/13/principle/room11f.svg`,
  "room-20-off": `${config.ASSETS_URL}/03/13/principle/room12.svg`,
  "room-20-on": `${config.ASSETS_URL}/03/13/principle/room12f.svg`,
  "room-30-off": `${config.ASSETS_URL}/03/13/principle/room13.svg`,
  "room-30-on": `${config.ASSETS_URL}/03/13/principle/room13f.svg`,
};

const sounds = {
  sourceRoom: {
    jazzMusic: `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut.mp3`,
    crowdNoise: `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik.mp3`,
  },
  receiverRoom: {
    "jazzMusic-10-on-off": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.1_ddFlank_.mp3`,
    "jazzMusic-10-on-6dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.1_ddFlank_+6dB.mp3`,
    "jazzMusic-10-on-12dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.1_ddFlank_+12dB.mp3`,
    "jazzMusic-10-on-18dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.1_ddFlank_+18dB.mp3`,

    "jazzMusic-10-off-off": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.1_dd_.mp3`,
    "jazzMusic-10-off-6dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.1_dd_+6dB.mp3`,
    "jazzMusic-10-off-12dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.1_dd_+12dB.mp3`,
    "jazzMusic-10-off-18dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.1_dd_+18dB.mp3`,

    "jazzMusic-20-on-off": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.2_ddFlank_.mp3`,
    "jazzMusic-20-on-6dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.2_ddFlank_+6dB.mp3`,
    "jazzMusic-20-on-12dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.2_ddFlank_+12dB.mp3`,
    "jazzMusic-20-on-18dB": `${config.ASSETS_URL}/03/13/principle/musicMR0804_JesperBuhlTrio_Full_cut_d0.2_ddFlank_+18dB.mp3`,

    "jazzMusic-20-off-off": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.2_dd_.mp3`,
    "jazzMusic-20-off-6dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.2_dd_+6dB.mp3`,
    "jazzMusic-20-off-12dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.2_dd_+12dB.mp3`,
    "jazzMusic-20-off-18dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.2_dd_+18dB.mp3`,

    "jazzMusic-30-on-off": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.3_ddFlank_.mp3`,
    "jazzMusic-30-on-6dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.3_ddFlank_+6dB.mp3`,
    "jazzMusic-30-on-12dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.3_ddFlank_+12dB.mp3`,
    "jazzMusic-30-on-18dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.3_ddFlank_+18dB.mp3`,

    "jazzMusic-30-off-off": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.3_dd_.mp3`,
    "jazzMusic-30-off-6dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.3_dd_+6dB.mp3`,
    "jazzMusic-30-off-12dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.3_dd_+12dB.mp3`,
    "jazzMusic-30-off-18dB": `${config.ASSETS_URL}/03/13/principle/music/MR0804_JesperBuhlTrio_Full_cut_d0.3_dd_+18dB.mp3`,

    "crowdNoise-10-on-off": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.1_ddFlank_.mp3`,
    "crowdNoise-10-on-6dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.1_ddFlank_+6dB.mp3`,
    "crowdNoise-10-on-12dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.1_ddFlank_+12dB.mp3`,
    "crowdNoise-10-on-18dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.1_ddFlank_+18dB.mp3`,

    "crowdNoise-10-off-off": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.1_dd_.mp3`,
    "crowdNoise-10-off-6dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.1_dd_+6dB.mp3`,
    "crowdNoise-10-off-12dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.1_dd_+12dB.mp3`,
    "crowdNoise-10-off-18dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.1_dd_+18dB.mp3`,

    "crowdNoise-20-on-off": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.2_ddFlank_.mp3`,
    "crowdNoise-20-on-6dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.2_ddFlank_+6dB.mp3`,
    "crowdNoise-20-on-12dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.2_ddFlank_+12dB.mp3`,
    "crowdNoise-20-on-18dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.2_ddFlank_+18dB.mp3`,

    "crowdNoise-20-off-off": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.2_dd_.mp3`,
    "crowdNoise-20-off-6dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.2_dd_+6dB.mp3`,
    "crowdNoise-20-off-12dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.2_dd_+12dB.mp3`,
    "crowdNoise-20-off-18dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.2_dd_+18dB.mp3`,

    "crowdNoise-30-on-off": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.3_ddFlank_.mp3`,
    "crowdNoise-30-on-6dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.3_ddFlank_+6dB.mp3`,
    "crowdNoise-30-on-12dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.3_ddFlank_+12dB.mp3`,
    "crowdNoise-30-on-18dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.3_ddFlank_+18dB.mp3`,

    "crowdNoise-30-off-off": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.3_dd_.mp3`,
    "crowdNoise-30-off-6dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.3_dd_+6dB.mp3`,
    "crowdNoise-30-off-12dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.3_dd_+12dB.mp3`,
    "crowdNoise-30-off-18dB": `${config.ASSETS_URL}/03/13/principle/music/PartyMix_mitMusik_d0.3_dd_+18dB.mp3`,
  },
};

const principle: Slide = {
  description:
    "In this example you can observe how acoustic screen height influence the acoustic environment of a street cross junction.",
  theory: theory,
  layout: {
    type: "custom031300",
    options: {
      sounds,
      images,
    },
  },
};

export default principle;
